// @ts-strict-ignore
import type { AttributeDescriptionTokens, PresentationalToken } from 'flow/editor/components/mla/types';
import { MLATokenType } from './constants';
import type { MLADataTokens } from './mla';

export function generateTokensWithLabelCasing({
  processedTokens,
}: {
  processedTokens: PresentationalToken[];
}): PresentationalToken[] {
  return processedTokens.map(token => {
    const conditionallyLowercaseLabel = token.label === 'The' ? token.label : token.label?.toLowerCase();
    return {
      ...token,
      label: conditionallyLowercaseLabel,
    };
  });
}

export function deleteTokenByLabel({
  type,
  tokens,
  tokenLabel,
}: {
  type: MLATokenType;
  tokens: MLADataTokens<MLATokenType>;
  tokenLabel: string;
}) {
  const indexOfToken = tokens.findIndex(token => (
    type === MLATokenType.FILTER
      ? token.string === tokenLabel
      : token.label === tokenLabel
  ));
  tokens.splice(indexOfToken, 1);
  return tokens;
}

export function customizeAHBalanceMLAFootnote({
  processedTokens,
}: {
  processedTokens: PresentationalToken[];
}) {
  let presentationalTokens = generateTokensWithLabelCasing({ processedTokens });
  presentationalTokens = deleteTokenByLabel({
    type: MLATokenType.FOOTNOTE,
    tokens: presentationalTokens,
    tokenLabel: 'of',
  }) as PresentationalToken[];
  return presentationalTokens;
}

export function customizeAHBalanceMLAEditableFilters({
  tokensWithIndex,
}: {
  tokensWithIndex: AttributeDescriptionTokens;
}) {
  return deleteTokenByLabel({
    type: MLATokenType.FILTER,
    tokens: tokensWithIndex,
    tokenLabel: 'of',
  }) as AttributeDescriptionTokens;
}

export function customizeAHStatusMLAFootnote({
  processedTokens,
}: {
  processedTokens: PresentationalToken[];
}) {
  let presentationalTokens = generateTokensWithLabelCasing({ processedTokens });
  presentationalTokens = deleteTokenByLabel({
    type: MLATokenType.FOOTNOTE,
    tokens: processedTokens,
    tokenLabel: 'status',
  }) as PresentationalToken[];

  const statusDetailTokenIndex = presentationalTokens.findIndex(token => token.placeholder === '{account_status_detail}');
  if (statusDetailTokenIndex > -1) {
    const statusDetail = presentationalTokens[statusDetailTokenIndex].value;
    if (typeof statusDetail === 'number' || typeof statusDetail === 'string') {
      presentationalTokens[statusDetailTokenIndex].value = [statusDetail];
    }
    const incomingValue = (presentationalTokens[statusDetailTokenIndex].value as (string | number)[]).join('/');
    if (incomingValue.length > 0) {
      presentationalTokens[statusDetailTokenIndex].label = `the following details: ${incomingValue},`;
      presentationalTokens[statusDetailTokenIndex].value = null;
      presentationalTokens[statusDetailTokenIndex].component = null;
    } else {
      presentationalTokens.splice(statusDetailTokenIndex, 1);
    }
  }

  const reasonsTokenIndex = presentationalTokens.findIndex(token => token.label === 'reasons');
  presentationalTokens.splice(reasonsTokenIndex, 1);
  return presentationalTokens;
}
